import { useState } from "react";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { toast } from "sonner";
import { ThumbsUp, ThumbsDown, MessageCircle, CheckCircle2 } from "lucide-react";

export function TutorialFeedback({ slug }) {
  const { openWhatsApp } = useSettings();
  const [feedback, setFeedback] = useState(null);

  const send = (helpful) => {
    setFeedback(helpful);
    api.post(`/tutorials/${slug}/feedback`, { helpful }).catch(() => {});
    if (helpful) toast.success("Que ótimo! 🎉");
  };

  return (
    <div className="ci-card p-8 mt-10 text-center">
      <h3 className="text-xl font-bold mb-1">Conseguiu configurar?</h3>
      <p className="text-gray-400 text-sm mb-5">Seu feedback ajuda a melhorar nossos tutoriais.</p>
      {feedback === null && (
        <div className="flex justify-center gap-3">
          <button onClick={() => send(true)} data-testid="feedback-yes-btn"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 hover:bg-emerald-500/25 transition">
            <ThumbsUp className="w-4 h-4" /> SIM, FUNCIONOU
          </button>
          <button onClick={() => send(false)} data-testid="feedback-no-btn"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold bg-red-500/15 text-red-300 border border-red-500/30 hover:bg-red-500/25 transition">
            <ThumbsDown className="w-4 h-4" /> PRECISO DE AJUDA
          </button>
        </div>
      )}
      {feedback === true && <div className="inline-flex items-center gap-2 text-emerald-300"><CheckCircle2 className="w-5 h-5" /> Obrigado pelo retorno!</div>}
      {feedback === false && (
        <div className="mt-2">
          <p className="text-gray-400 text-sm mb-3">Sem problemas! Fale com nosso suporte e resolvemos juntos.</p>
          <button onClick={() => openWhatsApp(`tutorial-help-${slug}`)} data-testid="feedback-whatsapp-btn"
            className="ci-btn-wa inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-semibold hover:brightness-110 transition">
            <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
          </button>
        </div>
      )}
    </div>
  );
}
